module.exports = __webpack_public_path__ + "img/elite_brown_ba_list.aed26fab.jpg";